import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import React, { useEffect, useState } from "react";
import './Tickets.scss'
import Filtros from "./partes/Filtros";
import Tabla from "./partes/Tabla";
import { getAministrativos, getGasolineras, getTickets } from "./integracion";
import ModalNuevo from "./partes/ModalNuevo";
import { getOperadores } from "../Bitacoras/integracion";
import ModalEditar from "./partes/ModalEditar";
// Datos simulados para selects y tabla


export default function VistaCombustible() {
    const [filtros, setFiltros] = useState({
        id: null,
        unidad: null,
        kilometraje: null,
        folio: null,
        desde: new Date(),
        hasta: new Date(),
        operador: null,
        administrativo: null,
        gasolinera: null,
        viaCaptura: null,
    });
    const [visible, setVisible] = useState(false);
    const [visibleEditar, setvisibleEditar] = useState(false);
    const [datos, setDatos] = useState([]);
    const [operadores, setOperadores] = useState([])
    const [administrativos, setAdministrativos] = useState([])
    const [viaCapturas, setViaCapturas] = useState([])
    const [gasolineras, setGasolineras] = useState([])
    const [columnaSeleccionada, setColumnaSeleccionada] = useState(null)
    const combistibles = [{ name: "Gasolina", code: 1 }, { name: "Diesel", code: 2 }]
    // aqui se obtienen los options de que van en los selects 
    useEffect(() => {
        const getOptionsBySelects = async () => {
            await getGasolineras(setGasolineras)
            await getOperadores(setOperadores)
            await getAministrativos(setAdministrativos)
            setViaCapturas([{ name: "App", code: 0 }, { name: "Manual", code: 1 }])
        }
        getOptionsBySelects()
    }, [])
    useEffect(() => {
        const getTicketPrimeraVez = async () => {
            await buscar()
        }
        getTicketPrimeraVez()
    }, [])
    const buscar = async () => {
        await getTickets(filtros, setDatos)
    }
    const limpiar = () => {
        setFiltros(
            {
                id: null,
                unidad: null,
                kilometraje: null,
                folio: null,
                desde: new Date(),
                hasta: new Date(),
                operador: null,
                administrativo: null,
                gasolinera: null,
                viaCaptura: null,
            }
        )
    }

    return (
        <div className="vista-combustible">
            <Filtros
                filtros={filtros}
                setFiltros={setFiltros}
                operadores={operadores}
                administrativos={administrativos}
                viaCapturas={viaCapturas}
                gasolineras={gasolineras}

            ></Filtros>

            <div className="botones-acciones">
                <Button label="Nuevo" icon="pi pi-plus"  onClick={() => { setVisible(true) }} />
                <Button label="Buscar" icon="pi pi-search" severity="secondary" onClick={() => buscar()} />
                <Button label="Limpiar" icon="pi pi-times" severity="secondary" onClick={() => limpiar()} />
            </div>

            <Tabla datos={datos}
                setColumnaSeleccionada={setColumnaSeleccionada}
                setvisibleEditar={setvisibleEditar}
                setDatos={setDatos}
                filtros={filtros}
            ></Tabla>
            <ModalNuevo
                operadores={operadores}
                administrativos={administrativos}
                viaCapturas={viaCapturas}
                gasolineras={gasolineras}
                combistibles={combistibles}
                setDatos={setDatos}
                filtros={filtros}
                visible={visible} onHide={() => { setVisible(false) }}></ModalNuevo>
            <ModalEditar
                operadores={operadores}
                administrativos={administrativos}
                viaCapturas={viaCapturas}
                gasolineras={gasolineras}
                combistibles={combistibles}
                setDatos={setDatos}
                filtros={filtros}
                columnaSeleccionada={columnaSeleccionada}
                setColumnaSeleccionada={setColumnaSeleccionada}
                visible={visibleEditar} onHide={() => { setvisibleEditar(false) }} />
        </div>
    );
}